export enum FamilialMedicalHistory {
  YES_TWO_OR_MORE = 'YES_TWO_OR_MORE',
  NO_ONLY_ONE = 'NO_ONLY_ONE',
  NO = 'NO',
}
